<template>
  <div>
    <div class="text-center mt-4" v-if="Business">
      <img v-if="Business.imageUrl" height="50" :src="Business.imageUrl" alt="Logo" />

      <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
      <div>
        <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{ Business.city
          }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
        <span v-if="Business.zip">{{ Business.zip }}</span>
      </div>
      <div v-if="Business.phoneNumber">
        {{ Business.phoneNumber | USPhoneNumber }}
      </div>
    </div>
    <v-container grid-list-lg :fluid="$vuetify.breakpoint.xsOnly" v-if="Counters">
      <v-card outlined>
        <v-card-title class="subtitle-1 font-weight-bold pa-4 ">Counter Controller</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-list dense class="py-0">
            <v-list-item two-line v-for="(item, i) in Counters" :key="i">
              <v-list-item-action>
                <v-btn depressed color="primary" @click="plus(item)" x-small fab>
                  <v-icon>mdi mdi-plus</v-icon>
                </v-btn>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title>
                  <strong>{{ item.dep }}</strong> - {{ `${item.received}/${item.needed} - ${item.name}` }}
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn depressed :disabled="parseInt(item.received) === 0" color="error" @click="minus(item)" x-small
                  fab>
                  <v-icon>mdi mdi-minus</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import applicationService from "@/modules/Application/service.js";
import counterService from "../service.js";
export default {
  name: 'counter-controller',
  data() {
    return {
      Business: null,
      Counters: null,
      loading: false,
    }
  },
  created() {
    if (!this.$route.params.id)
      this.$router.push({ name: "pagenotfound" });
    this.loadBusiness()
    this.loadCounter()
    // this.joinRoom()
  },
  methods: {
    loadBusiness() {
      let id = this.$route.params.id;
      applicationService
        .getBusinessInformation({ key: id })
        .then((response) => {
          this.Business = response.data;
        })
        .catch((error) => {
          console.log("error getting business", error);
          this.$router.push({ name: "pagenotfound" });
        });
    },
    loadCounter() {
      let id = this.$route.params.id;
      counterService
        .getPublicCounterList({ key: id })
        .then((response) => {
          this.Counters = response.data
        })
        .catch((error) => {
          console.log("error getting Counters", error);
        });
    },
    minus(item) {
      item.received = parseInt(item.received) - 1
      this.submit(item)
    },
    plus(item) {
      item.received = parseInt(item.received) + 1
      // console.log('plus', item)
      this.submit(item)
    },
    submit(item) {
      // console.log('item', item)
      this.loading = true;
      let key = this.$route.params.id;
      return counterService
        .updateById(key, item)
        .then((result) => {
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Counter is updated",
              });
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },
  }

}
</script>

<style scoped></style>